import { gql } from 'graphql-request'

export const CHECK_WRITER_EXIST = gql`
  query CheckWriterExist($writerIds: [Int!]!) {
    checkWriterExist(writerIds: $writerIds)
  }
`
